export enum GradeTargetStatus {
  OK = "ok",
  WARN = "warn",
  BLOCK = "block",
}

export enum GradeTargetReason {
  ITEM_NEVER_SOLD = "ITEM_NEVER_SOLD",
  COLOR_NEVER_SOLD = "COLOR_NEVER_SOLD",
  SIZE_NEVER_SOLD = "SIZE_NEVER_SOLD",
  COMBINATION_NEVER_SOLD = "COMBINATION_NEVER_SOLD",
}

export interface IGradeCatalogEntry {
  code: string;
  description: string;
}

export interface IGradeCatalog {
  colors: IGradeCatalogEntry[];
  sizes: IGradeCatalogEntry[];
}

export interface IGradeAxisEntry {
  code: string;
  description: string | null;
  sales: number;
  lastSaleDate: string | null;
}

export interface IGradeCombination {
  color: string;
  size: string;
  sales: number;
  lastSaleDate: string | null;
}

export interface IItemGradeHistory {
  itemCode: string;
  hasHistory: boolean;
  totalSales: number;
  colors: IGradeAxisEntry[];
  sizes: IGradeAxisEntry[];
  combinations: IGradeCombination[];
}

export interface IGradeTarget {
  color: string | null;
  size: string | null;
}

export interface IGradeTargetPayload extends IGradeTarget {
  itemCode: string;
}

export interface IGradeTargetIssue extends IGradeTargetPayload {
  status: GradeTargetStatus;
  reason: GradeTargetReason;
}

export interface IValidateGradeTargetsResponse {
  blocked: IGradeTargetIssue[];
  warnings: IGradeTargetIssue[];
}

export interface IItemGradeTargetsResponse {
  targets: IGradeTarget[];
}

export interface IReplaceGradeTargetsRequest {
  code: number;
  itemCode: string;
  targets: IGradeTargetPayload[];
}

export interface IReplaceGradeTargetsResponse {
  replaced: number;
  hasGrade: boolean;
}

export interface IValidateGradeTargetsRequest {
  targets: IGradeTargetPayload[];
}
